module.exports = __webpack_public_path__ + "roundabout_sharp_left.svg?d16bf0c09fc79d542a67d91e6c7ccdd6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/roundabout_sharp_left.svg
// module id = 218
// module chunks = 0